import { render, staticRenderFns } from "./GlassCard.vue?vue&type=template&id=3182a484&scoped=true"
import script from "./GlassCard.vue?vue&type=script&lang=js"
export * from "./GlassCard.vue?vue&type=script&lang=js"
import style0 from "./GlassCard.vue?vue&type=style&index=0&id=3182a484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3182a484",
  null
  
)

export default component.exports